import type { ApiResponse } from './common';

export enum CurrencyCode {
  EUR = 'EUR',
  USD = 'USD',
  GBP = 'GBP',
  CHF = 'CHF',
  AUD = 'AUD',
  ZAR = 'ZAR',
  DKK = 'DKK',
  SEK = 'SEK',
  NOK = 'NOK',
  CAD = 'CAD',
  HKD = 'HKD',
  PLN = 'PLN',
  JPY = 'JPY',
  RUB = 'RUB',
  SGD = 'SGD',
  NZD = 'NZD',
}

export interface CurrencyOption {
  value: string;
  label: string;
}

export interface SaveCurrencyResponse {
  success: boolean;
  error?: string;
  data?: {
    currencyCode: CurrencyCode;
    dmi: unknown;
    cgi: unknown;
  };
}

type CurrenciesApiDataItem = { code?: string; Code?: string; Currency?: string };

export type CurrenciesApiData = string[] | Array<CurrenciesApiDataItem>;

export type CurrenciesApiResponse = ApiResponse<CurrenciesApiData>;

export type RawCurrency = string | Record<string, unknown>;
